import React from "react";

// The announcement (megaphone) icon, inline rather than as an <img> of the CDN
// file so its colour comes from CSS: it fills with `currentColor`. Paths are
// copied unchanged from cdn.solssmart.org/static/assets/announcement-icon.svg.
// Decorative, so hidden from assistive tech.
const AnnouncementIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 499.95 459.1"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M413.33,311.71h0L97.56,416a67.89,67.89,0,0,1-76.45-25.43l-9.07-13A67.87,67.87,0,0,1,14.5,297L221.19,36.53a14.48,14.48,0,0,1,23.23.72L420.11,288.88a14.71,14.71,0,0,1,2.44,4.5,14.49,14.49,0,0,1-9.19,18.32h0M231.8,69.8,37.21,315.05A38.71,38.71,0,0,0,35.81,361l9.07,13a38.69,38.69,0,0,0,43.58,14.5l297.28-98.16Z" />
    <path d="M205.84,454.5c-45.17,15-92.84-7.78-108.52-51.83A14.49,14.49,0,1,1,124.63,393c10.35,29.06,42,44,72.08,34a57.73,57.73,0,0,0,35.11-32.59,14.5,14.5,0,0,1,26.76,11.16,86.7,86.7,0,0,1-52.74,48.95" />
    <path d="M413.33,311.71h0L299.15,349.41A14.5,14.5,0,0,1,282.72,344L145.93,148a14.5,14.5,0,0,1,.53-17.31l74.73-94.18a14.48,14.48,0,0,1,23.23.72L420.65,289.66a14.49,14.49,0,0,1-7.32,22m-113,6.79,85.43-28.21L231.8,69.8l-55.92,70.48Z" />
    <path d="M433,339.49A14.49,14.49,0,0,1,416.54,334L201.36,25.82a14.5,14.5,0,0,1,23.77-16.6L440.31,317.43A14.51,14.51,0,0,1,433,339.49" />
    <path d="M368.4,64.51a14.49,14.49,0,0,1-21.08-12.43L346.08,15a14.49,14.49,0,1,1,29-1l1.24,37.1a14.48,14.48,0,0,1-7.89,13.4" />
    <path d="M432.11,111.44a14.5,14.5,0,0,1-14.64-24.79l30-22.86A14.5,14.5,0,0,1,465,86.85l-30,22.85a15,15,0,0,1-2.94,1.74" />
    <path d="M489.5,213.64a14.4,14.4,0,0,1-9.39-.44L445.6,199.51a14.5,14.5,0,0,1,10.69-26.95l34.51,13.69a14.49,14.49,0,0,1-1.3,27.39" />
    <path d="M369.91,134.64a51.27,51.27,0,0,0-71.37-12.81L357.1,206A51.27,51.27,0,0,0,369.91,134.64Z" />
  </svg>
);

export default AnnouncementIcon;
